import React from 'react';

const gaScript = `
  var gaUrl = 'https://www.google-analytics.com/collect';
  var gaParams = {
    v: '1',
    t: 'pageview',
    tid: 'UA-2958380-25',
    cid: crypto.randomUUID(),
    dl: window.location.href
  };
  var gaPostBody = new URLSearchParams(gaParams).toString();
  fetch(gaUrl, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: gaPostBody
  });
`;

/**
 * Use only for newspartners stories to track users on republished articles
 */
const GoogleAnalytics = () => {
  return <script dangerouslySetInnerHTML={{ __html: gaScript }}></script>;
};

export default GoogleAnalytics;
